
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("3x2ID", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $439277a0e93a5432$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Portuguese (Brazil)
var $439277a0e93a5432$export$2e2bcd8739ae039 = {
    'confluence.error.panel.refresh.app': 'Atualizar app',
    'confluence.error.panel.reload.page': "Recarregar p\xe1gina",
    'confluence.icon.label': "\xcdcone",
    'confluence.modal.dialog.close.modal.button': 'Cancelar',
    'confluence.select.required.field.message': "Este campo \xe9 obrigat\xf3rio.",
    'confluence.text.area.required.field.message': "Este campo \xe9 obrigat\xf3rio.",
    'confluence.textfield.validator.email': "Insira um e-mail v\xe1lido.",
    'confluence.textfield.validator.number': "Insira um n\xfamero v\xe1lido",
    'confluence.textfield.validator.required.field.message': "Este campo \xe9 obrigat\xf3rio.",
    'confluence.textfield.validator.telephone': "Insira um telefone v\xe1lido.",
    'confluence.threeLOPrompt.modal.access.required.title': "Acesso obrigat\xf3rio",
    'confluence.threeLOPrompt.modal.error.title': 'Erro',
    'confluence.threeLOPrompt.modal.no.authURL.error-message': "URL de consentimento n\xe3o encontrada. Atualize a p\xe1gina e tente de novo.",
    'confluence.threeLOPrompt.no.authURL.error-message': "URL de consentimento n\xe3o encontrada. Atualize a p\xe1gina e tente de novo.",
    'confluence.threeLOPrompt.use-auth.allow.access.button.text': 'Permitir acesso',
    'confluence.threeLOPrompt.use-auth.configure.access.button.text': 'Configurar acesso',
    'confluence.threeLOPrompt.use-auth.default.failed.to.auth.message': "Falha na autentica\xe7\xe3o.",
    'confluence.threeLOPrompt.use-auth.default.prompt.message': "Para exibir {appString}, voc\xea precisa permitir que o app acesse os produtos da Atlassian em seu nome.",
    'confluence.threeLOPrompt.use-auth.external.auth.prompt.message': "{appString} requer acesso adicional \xe0 conta.",
    'confluence.threeLOPrompt.use-auth.external.auth.warning.message': "Aviso de autentica\xe7\xe3o externa",
    'confluence.threeLOPrompt.use-auth.this.app.lower.message': 'este app',
    'confluence.threeLOPrompt.use-auth.this.app.upper.message': 'Este app',
    'confluence.user.group.unknown.user.message': "Usu\xe1rio desconhecido",
    'confluence.user.picker.empty.field.error.message': "Este campo \xe9 obrigat\xf3rio.",
    'confluence.user.unknown.user.message': "Usu\xe1rio desconhecido",
    'forge-ui.form.submit-button.text': 'Enviar'
};

});


//# sourceMappingURL=pt_BR.55c825b3.js.map
